import { FC, useMemo } from "react";
import KickImage from 'Reuseables/KickImage';
import moment from "moment";

//Interface
import { TimeslotCardInterface, TIMESLOT } from "../definitions";

const Dropoff: FC<TimeslotCardInterface> = ({
  selectedDate,
  selectedScheduled,
  setSelectedScheduled
}) => {
  if (!selectedDate?.timeslot?.length) return null;
  const timeslot = useMemo(() => {
    const day = selectedDate?.fullDay;
    const today = moment().day();

    if (today != moment(day).day()) {
      return TIMESLOT.map(e => ({...e, isPassed: false}))
    }
    return TIMESLOT.map(slot => {
      let result = { ...slot, isPassed: false }
      let hours = moment(day).hours()

      if (hours > result.end_time_eum) {
        result.isPassed = true
      }
      return result
    })
  }, [selectedDate])

  return (
    <>
      <p className="scheduled-title">Set Drop-off Time (WIB)</p>
      <div className="scheduled-card-wrapper time-wrapper">
        {
          timeslot.length && timeslot.map((time, idx) => {
            const lastItem = (idx === timeslot.length - 1) ? "lastitem" : ""
            const selected = `${selectedScheduled?.start_time}${selectedScheduled?.end_time}` === `${time?.start_time}${time?.end_time}`;

            if (time?.isPassed) return null;
            return (
              <div key={idx} className={`time-card ${lastItem} ${selected ? "active" : ""}`} onClick={() => setSelectedScheduled({ start_time: time.start_time, end_time: time.end_time })}>
                <p>
                  <span>{time.start_time}</span>
                  {" - "}
                  <span>{time.end_time}</span>
                </p>
              </div>
            )
          })
        }
      </div>
    </>
  )
}

export default Dropoff;